import { render } from "./TimelineSmall.vue?vue&type=template&id=ce470256&scoped=true"
import script from "./TimelineSmall.vue?vue&type=script&lang=js"
export * from "./TimelineSmall.vue?vue&type=script&lang=js"

import "./TimelineSmall.vue?vue&type=style&index=0&id=ce470256&scoped=true&lang=scss"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce470256"]])

export default __exports__